<template>
	<div>
		<v-row>
			<v-col
				:cols="$vuetify.breakpoint.mobile ? 3 : 4"
			>
				<v-img
					contain
					alt="Hydrangeas"
					:max-width="`${cornerImageScale}vw`"
					:max-height="`${cornerImageScale}vw`"
					:src="require('@/assets/HydrangeasCorner.png')"
				/>
			</v-col>
			<v-col
				:cols="$vuetify.breakpoint.mobile ? 6 : 4"
			>
				<p
					class="cursive text-center text-no-wrap"
					:style="`margin-top: ${cornerImageScale / 4}vw; font-size: ${headerFontSize}`"
				>
					Savannah & Jacob<br/>
					9/1/2023
				</p>
			</v-col>
			<v-col
				:cols="$vuetify.breakpoint.mobile ? 3 : 4"
			>
				<v-img
					contain
					alt="Hydrangeas"
					:max-width="`${cornerImageScale}vw`"
					:max-height="`${cornerImageScale}vw`"
					class="ml-auto"
					style="transform: scaleX(-1)"
					:src="require('@/assets/HydrangeasCorner.png')"
				/>
			</v-col>
		</v-row>
	</div>
</template>

<script>
	export default {
		name: "Header",

		data: () => ({
			cornerImageScale: 20,
			headerFontSize: "5vw"
		}),

		created() {
			this.cornerImageScale = this.cornerSizing()
			this.headerFontSize = this.headerFontSizing()
			window.addEventListener("resize", this.windowResizing);
		},
		destroyed() {
			window.removeEventListener("resize", this.windowResizing);
		},
		methods: {
			cornerSizing() {
				return this.$vuetify.breakpoint.mobile ? 33 : 20;
			},
			headerFontSizing() {
				return (this.$vuetify.breakpoint.mobile ? 6.5 : 2.5) + "vw";
			},
			windowResizing() {
				this.cornerImageScale = this.cornerSizing()
			}
		}
	}
</script>

<style scoped>

</style>
